import { useMemo } from 'react'

import { useManualTaskProcessorToolkit } from 'Automations/nodeDefinitions/hooks/useManualTaskProcessorToolkit'
import {
  InvoiceUpdateReviewInput,
  InvoiceUpdateReviewOutcome,
  InvoiceUpdateReviewViewModel
} from '../types'
import { mapInputToViewModel } from '../invoiceUpdateReview.helpers'

type UseInvoiceUpdateReviewTask = {
  viewModel: InvoiceUpdateReviewViewModel | undefined
  isPending: boolean
  handleClose: () => void
  completeTask: (outcome: InvoiceUpdateReviewOutcome) => Promise<boolean>
}

/**
 * Data seam for the invoice-update review modal. Reads and completes the task
 * through the shared `useManualTaskProcessorToolkit` (real `getManualTask` /
 * `postCompleteManualTask`), and maps the raw task input into the view model the
 * components consume.
 */
export const useInvoiceUpdateReviewTask = ({
  taskId
}: {
  taskId: string
}): UseInvoiceUpdateReviewTask => {
  const { manualTask, isPending, handleClose, completeTask } =
    useManualTaskProcessorToolkit<InvoiceUpdateReviewInput>({ taskId })

  const viewModel = useMemo(
    () =>
      manualTask?.input ? mapInputToViewModel(manualTask.input) : undefined,
    [manualTask?.input]
  )

  return {
    viewModel,
    isPending,
    handleClose,
    completeTask
  }
}
